import { graphql } from 'react-relay';

export const homeFundInfoserviceSectionFragment = graphql`
    fragment HomeFundInfoserviceSection_pageSection on HomeFundInfoservice {
        title
        titleImageUrl
        titleImageBackgroundUrl
        anchorName
        text
        loginLink
        registrationLink
        loginText
        registrationText
    }
`;
